import { getMinRateString, generateTermRange, getTermRangeToString, getMaxAmount } from '../../helpers/humanization.js';

const getBusinessCreditsTerms = item => {
    // Поля: Сумма, Срок. Ставка, без залога
    const conditions = [];
    const { minRate, maxRate, minSum, maxSum, dictDateFrom, dictDateTo, minTime, maxTime } = item;
    const rate = {
        from: minRate,
        to: maxRate,
    };
    const amount = {
        from: minSum,
        to: maxSum,
    };
    const rateValue = getMinRateString(rate, true);
    let rateDescription = 'Ставка';
    if (item.dictAdvantages?.includes('factoring')) {
        rateDescription = 'Комиссия';
    }
    if (item.rateTerm?.includes('year')) {
        rateDescription = `${rateDescription} в год`;
    }
    else {
        rateDescription = `${rateDescription} в месяц`;
    }
    rateValue && conditions.push({ value: rateValue, description: 'Ставка', key: 'rate', labelKey: 'rateDescription' });
    rateDescription &&
        conditions.push({
            value: rateDescription,
            description: 'Условия',
            key: 'rateDescription',
        });
    const nozalog = item.dictAdvantages?.includes('nozalog');
    conditions.push({ value: nozalog ? 'Да' : 'Нет', description: 'Без залога', key: 'nozalog' });
    const termRange = generateTermRange({
        dictDateFrom,
        from: minTime,
        dictDateTo,
        to: maxTime,
    });
    const termValue = getTermRangeToString(termRange, 'Индивидуально');
    termValue &&
        conditions.push({
            value: termValue,
            description: 'Срок',
            key: 'term',
        });
    const amountValue = getMaxAmount(amount, {
        postfix: ' ₽',
        isConvert: true,
        prefix: true,
    });
    amountValue &&
        conditions.push({
            value: amountValue,
            description: 'Сумма',
            key: 'amount',
        });
    return conditions;
};

export { getBusinessCreditsTerms };
//# sourceMappingURL=businessCredits.js.map
